export default __webpack_public_path__ + "static/media/fad-caret-right.4814a656.svg";